"use strict";
/**
 * Copyright 2014-present Palantir Technologies
 * @license MIT
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var TickGenerators = require("./tickGenerators");
exports.TickGenerators = TickGenerators;
tslib_1.__exportStar(require("./categoryScale"), exports);
tslib_1.__exportStar(require("./colorScale"), exports);
tslib_1.__exportStar(require("./interpolatedColorScale"), exports);
tslib_1.__exportStar(require("./linearScale"), exports);
tslib_1.__exportStar(require("./logScale"), exports);
tslib_1.__exportStar(require("./modifiedLogScale"), exports);
tslib_1.__exportStar(require("./timeScale"), exports);
// ---------------------------------------------------------
var categoryScale_1 = require("./categoryScale");
var quantitativeScale_1 = require("./quantitativeScale");
/**
 * Type guarded function to check if the scale implements the
 * `TransformableScale` interface. Unfortunately, there is no way to do
 * runtime interface typechecking, so we have to explicitly list all classes
 * that implement the interface.
 */
function isTransformable(scale) {
    return (scale instanceof quantitativeScale_1.QuantitativeScale ||
        scale instanceof categoryScale_1.Category);
}
exports.isTransformable = isTransformable;



//////////////////
// WEBPACK FOOTER
// ./src/scales/index.ts
// module id = 4
// module chunks = 0